import { useEffect } from 'react';

// cb: returns void or a cleanup function that returns void
export function useMountEffect(cb: () => void | (() => void)) {
  useEffect(cb, []);
}
